export const MAI_SUBTAGS = {
  GLOBALLY_UNIQUE_ID: "00",
} as const;
